import { PER_SPLIT_AMOUNT_MIN } from '@constants/generic';
import { RootState, useAppSelector } from '@core/store';
import { useGetBranchByIdQuery } from '@features/branch-management/queries';

type SplitAmountValue = string | number | null | undefined;

// userSlice types orgConfig as null, so narrow to the field read here.
type OrgSplitConfig = { per_split_amount_min?: SplitAmountValue } | null;

// Branch value wins when set (> 0); otherwise fall back to the org value.
export const resolvePerSplitAmountMin = (
  branchMin: SplitAmountValue,
  orgMin: SplitAmountValue
): number => {
  const branchValue = Number(branchMin);
  if (branchValue > 0) return branchValue;
  const orgValue = Number(orgMin);
  if (orgValue > 0) return orgValue;
  return PER_SPLIT_AMOUNT_MIN;
};

const usePerSplitAmountMin = (organizationId?: string, branchId?: string) => {
  const orgMin = useAppSelector(
    (state: RootState) =>
      (state.user.orgConfig as OrgSplitConfig)?.per_split_amount_min
  );
  const { data: branchDetails } = useGetBranchByIdQuery(
    {
      params: {
        organizationId: organizationId ?? '',
        branchId: branchId ?? ''
      },
      queryString: '?include_fee_categories=false&include_payment_stats=false'
    },
    { skip: !organizationId || !branchId }
  );

  return resolvePerSplitAmountMin(
    branchDetails?.branch_config?.limits_config?.split_payment_limits
      ?.per_split_amount_min,
    orgMin
  );
};

export default usePerSplitAmountMin;
